export enum FormTemplateKey {
  VehicleDamage = "vehicle_damage",
  ThreatsAndViolence = "threats_and_violence",
  WorkingEnvironment = "working_environment",
  TrafficAndCustomerInfo = "traffic_and_customerinfo",
  TrafficLog = "traffic_log",
  SuggestionBox = "suggestion_box",
  VastanhedePersonalInjuries = "vastanhede_incident_personal_injuries",
  VastanhedeWorkingEnvironment = "vastanhede_working_environment",
  VastanhedeTrafficDisruption = "vastanhede_traffic_disruption",
  GotlandSchoolBus = "gotland_school_bus"
}
